import { Injectable } from '@angular/core';
import { ballotListRoute, ballotRoute, routesByDocumentType, declarationRoute, petitionRoute, returnOptionsRoute } from '../route-names';
import { ApiAboutService } from './api-about.service';
import { environment } from '../../environments/environment';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { DeclarationService } from '../declaration/declaration.service';
import { ElectorDataService } from '../Services/elector-data.service';

export type VerificationDocumentName = 'id' | 'headshot';
export type ScreenName = 'declaration' | 'home' | 'idv' | 'id' | 'headshot'; 
export type SelectedReturnMethod = 'ELECTRONIC' | 'PRINT';
export type ReturnOptions = 'ELECTRONIC' | 'ELECTRONICORPRINT' | 'PRINT';

@Injectable({
  providedIn: 'root'
})
export class ScreenOrderService {
  electronicOrPrintString: string = "ELECTRONICORPRINT";
  printString: string = "PRINT";
  returnMethods: ReturnOptions[] = []
  voterBallotType: ReturnOptions = "ELECTRONIC";
  selectedReturnMethod: SelectedReturnMethod = "ELECTRONIC";
  returnMethodSelected: boolean = true;
  verificationDocuments: Array<VerificationDocumentName> = [];

  constructor(
    private readonly about: ApiAboutService,
    private readonly ballotListService: BallotListService,
    private readonly declarationService: DeclarationService,
    private readonly userService: ElectorDataService
  ) {
    let returnOptions = this.about.aboutInformation.value.org_feature_set.miscSettings?.ballotReturnOptions;
    if(returnOptions) {
      if(returnOptions.electronicOrPrintValue) {
        this.electronicOrPrintString = returnOptions.electronicOrPrintValue;
        this.returnMethods.push("ELECTRONICORPRINT");
        this.returnMethodSelected == false;
      }
      if(returnOptions.printValue) {
        this.printString = returnOptions.printValue;
        this.returnMethods.push("PRINT");
        this.returnMethodSelected == false;
        if(this.returnMethods.length == 1 && this.returnMethods[0] === returnOptions.printValue) {
          this.selectedReturnMethod = "PRINT";
          this.returnMethodSelected = true;
        }
      }
    }
    if(this.about.isIDVflow()) {
      this.verificationDocuments = ['id', 'headshot'];
    }
  }

  private _ballotRoutes(): any[] {
    const ballotList = this.ballotListService.getBallots();
    if (ballotList.length > 1) {
      return ballotListRoute;
    } else if (this.voterBallotType == 'ELECTRONICORPRINT' && !this.returnMethodSelected) {
      return returnOptionsRoute;
    } else if (ballotList.length == 1 && ballotList[0].eventType?.toLowerCase() === 'petition'){
      return petitionRoute;
    } else {
      return ballotRoute;
    }
  }

  nextRoute(currentScreenName: ScreenName): any[] {
    const declarationRequired = this.declarationService.required
    const noVerifications = this.verificationDocuments.length === 0 || environment.pollingStation || this.userService.idvStatus() === 'SUCCESS';
    switch (currentScreenName) {
      case 'home': {
        if (declarationRequired) {
          return declarationRoute
        } else if (noVerifications) {
          return this._ballotRoutes()
        } else {
          return routesByDocumentType[this.verificationDocuments[0]];
        }
      }
      case 'declaration': {
        if (noVerifications) {
          return this._ballotRoutes()
        } else {
          return routesByDocumentType[this.verificationDocuments[0]];
        }
      }
      default: {
        const i = this.verificationDocuments.findIndex(d => d === currentScreenName);
        if (i < this.verificationDocuments.length - 1) {
          return routesByDocumentType[this.verificationDocuments[i + 1]];
        } else {
          return this._ballotRoutes();
        }
      }
    }
  }

  setVoterBallotType(returnMethod: string | undefined) {
    switch (returnMethod) {
      case this.electronicOrPrintString: {
        this.voterBallotType = "ELECTRONICORPRINT";
        this.returnMethodSelected = false;
        break;
      }
      case this.printString: {
        this.voterBallotType = "PRINT";
        this.selectedReturnMethod = "PRINT";
        this.returnMethodSelected = true;
        break;
      }
      default: {
        this.voterBallotType = "ELECTRONIC";
        this.selectedReturnMethod = "ELECTRONIC";
        this.returnMethodSelected = true;
        break;
      }
    }
  }

  routeSubmitBallotErrorToDashboard(): boolean {
    return this.about.hasDashboard;
  }
}
